import { Button, Tooltip } from '@missionlabs/smartagent-app-components'
import { Loader } from 'components'

import styles from './SendButton.module.scss'

interface Props {
    loading: boolean
    className?: string
    buttonClassName?: string
    disabled?: boolean
    toolTipText?: string
}

const SendButton = ({ loading, className, buttonClassName, disabled, toolTipText }: Props) => {
    return (
        <Tooltip text={toolTipText} className={styles.tooltip}>
            <div className={className}>
                <Button className={buttonClassName} styling="primary" disabled={disabled}>
                    {loading ? (
                        <Loader size={16} color="#fff" loaderType="clip" className="sm-pad" />
                    ) : (
                        'Send'
                    )}
                </Button>
            </div>
        </Tooltip>
    )
}

export default SendButton
